module.exports = __webpack_public_path__ + "img/github.aef4fb5c.svg";